import {formDataRequest, getRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceGetHierarchy(params) {
    return await postRequest('sales/target/hierarchy/report', params);
}
export async function serviceGetHierarchyExport(params) {
    return await postRequest('sales/target/hierarchy/report/export', params);
}
